import React from 'react';
import PropTypes from 'prop-types';
import Select from '@blaze-react/select';
import { DEFAULT_OPTION } from '../constants';

const SelectFilter = ({
  data,
  label,
  prop,
  updateFilterValues,
  filterValues,
  shouldSearch,
  displayLabelAsPlaceholder,
  displayFilterCount,
  elementTitle
}) => {
  const filterValue = filterValues[prop] || '';
  const disabledOptions = [];
  const { buckets = [] } = data[prop] || {};

  const options = buckets
    .map(({ key, doc_count: count }) => {
      if (!count) disabledOptions.push(key);
      const optionLabel = displayFilterCount ? `${key} (${count})` : key;
      return [key, optionLabel];
    })
    .filter(Boolean)
    .sort();

  const labelText = label || prop;
  let labelToUse = labelText;
  let defaultTextValue = DEFAULT_OPTION;
  if (displayLabelAsPlaceholder) {
    defaultTextValue = labelToUse;
    labelToUse = null;
  }

  return (
    <>
      {elementTitle && <div className="heading heading--section">{elementTitle}</div>}
      <Select
        label={labelToUse}
        value={filterValue}
        id={prop}
        name={`filter-${prop}`}
        data-testid={`filter-${prop}`}
        options={options}
        defaultTextValue={defaultTextValue}
        onChange={({ value }) => {
          let valueToUse = value;
          if (value === defaultTextValue) valueToUse = '';

          updateFilterValues({ [prop]: valueToUse }, shouldSearch);
        }}
        disabled={disabledOptions}
      />
    </>
  );
};

SelectFilter.propTypes = {
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  filterValues: PropTypes.object,
  updateFilterValues: PropTypes.func.isRequired,
  shouldSearch: PropTypes.bool,
  label: PropTypes.string,
  elementTitle: PropTypes.string,

  displayLabelAsPlaceholder: PropTypes.bool,
  displayFilterCount: PropTypes.bool
};

SelectFilter.defaultProps = {
  filterValues: {},
  shouldSearch: false,
  label: '',
  elementTitle: '',
  displayLabelAsPlaceholder: false,
  displayFilterCount: false
};

export default SelectFilter;
